import { System_instance34rnn1q53nv02 as System_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { BasicListenable3uz4a8xs34a0h as BasicListenable } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { AtomicIntuadhvz5dttw2 as AtomicInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/concurrent/atomics/Atomics.js.mjs';
import { incrementAndFetchzsy670lf6w2h as incrementAndFetch } from '../../../../../kotlin-kotlin-stdlib/kotlin/concurrent/atomics/Atomics.common.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  copyToArray2j022khrow2yi as copyToArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { generateSequence118suk3hffuuw as generateSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { mapsbvh18eqox7a as map } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import {
  plus3pcnntex3h8m as plus,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  singleOrNullrknfaxokm1sl as singleOrNull,
  plus20p0vtfmu0596 as plus_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import {
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  DataClassPathAccess3qupo9g6dhbeb as DataClassPathAccess,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_serializableProperties1162nosnaangd as get_serializableProperties,
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { SortParte7ewatwctfe4 as SortPart } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortPart.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { first22rf410wdc2iv as first } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Reduce.mjs';
import {
  boxApply1qmzdb3dh90hg as boxApply,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  Key_instancepi2bbb0csu5f as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { CoroutineScopelux7s7zphw7e as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  beginUse146s8dwmfk72s as beginUse,
  Reactive1jy75v4li6ldv as Reactive,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function now(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance_0);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.clock_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.now_2cba_k$();
  return tmp2_elvis_lhs == null ? System_instance.now_2cba_k$() : tmp2_elvis_lhs;
}
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance_0;
function Key_getInstance() {
  return Key_instance_0;
}
function InterruptibleDelay$delay$slambda($duration) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* delay($duration, $completion);
    return Unit_instance;
  }), 0);
}
function InterruptibleDelay$delay$lambda(it) {
  return it.parent_1;
}
function InterruptibleDelay$delay$lambda_0(inter) {
  var current = inter.num_1.load_1zbae_k$();
  return InterruptibleDelay$delay$lambda$slambda(inter, current);
}
function InterruptibleDelay$delay$lambda$slambda$lambda() {
  return Unit_instance;
}
function InterruptibleDelay$delay$lambda$slambda($inter, $current) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var closer = {_v: InterruptibleDelay$delay$lambda$slambda$lambda};
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    (yield () => {
      var uCont = $completion;
      var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
      cancellable.initCancellability_shqc60_k$();
      var cont = cancellable;
      var resumed = {_v: false};
      cont.invokeOnCancellation_kffkqp_k$((it) => {
        closer._v();
        return Unit_instance;
      });
      closer._v = $inter.listenable_1.addListener_6y9mct_k$(() => {
        var tmp;
        if (!resumed._v) {
          resumed._v = true;
          // Inline function 'kotlin.coroutines.resume' call
          var this_0 = cont;
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
          this_0.resumeWith_rk9gbt_k$(tmp$ret$5);
          tmp = Unit_instance;
        }
        return Unit_instance;
      });
      if ($inter.num_1.load_1zbae_k$() > $current) {
        if (!resumed._v) {
          resumed._v = true;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
          cont.resumeWith_rk9gbt_k$(tmp$ret$7);
        }
      }
      return cancellable.getResult_fck196_k$();
    });
    closer._v();
    return Unit_instance;
  }), 0);
}
var InterruptibleDelayClass;
function InterruptibleDelay() {
  if (InterruptibleDelayClass === VOID) {
    class $ {
      constructor(parent) {
        parent = parent === VOID ? null : parent;
        this.parent_1 = parent;
        this.listenable_1 = BasicListenable().new_com_lightningkite_reactive_core_BasicListenable_biohma_k$();
        this.num_1 = new (AtomicInt())(0);
      }
      interrupt_6jhqqb_k$() {
        incrementAndFetch(this.num_1);
        this.listenable_1.invokeAll_w2le0p_k$();
      }
      child_1kc9wc_k$() {
        return new (InterruptibleDelay())(this);
      }
      *delay_93os7b_k$(duration, $completion) {
        var tmp = listOf(InterruptibleDelay$delay$slambda(duration));
        var tmp_0 = generateSequence(this, InterruptibleDelay$delay$lambda);
        var toRace = plus(tmp, map(tmp_0, InterruptibleDelay$delay$lambda_0));
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$0 = copyToArray(toRace);
        yield* race(tmp$ret$0.slice(), $completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'InterruptibleDelay', InterruptibleDelay, VOID, VOID, [1]);
    InterruptibleDelayClass = $;
  }
  return InterruptibleDelayClass;
}
function ResourceUse(parentScope, action) {
  parentScope = parentScope === VOID ? get_AppScope() : parentScope;
  return new (ResourceUse$1())(parentScope, action);
}
function uses(_this__u8e3s4, resource) {
  return new (uses$1())(_this__u8e3s4, resource);
}
function ensureTotal(_this__u8e3s4, serializer) {
  var tmp0_safe_receiver = lastOrNull(_this__u8e3s4);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.field_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_properties_zhllqc_k$();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : singleOrNull(tmp2_safe_receiver);
  if ((tmp3_safe_receiver == null ? null : tmp3_safe_receiver.get_name_woqyms_k$()) === '_id')
    return _this__u8e3s4;
  var tmp = new (DataClassPathSelf())(serializer);
  // Inline function 'kotlin.collections.find' call
  var tmp0 = ensureNotNull(get_serializableProperties(serializer));
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.get_name_woqyms_k$() === '_id') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp_0 = tmp$ret$1;
  return plus_0(_this__u8e3s4, new (SortPart())(new (DataClassPathAccess())(tmp, (!(tmp_0 == null) ? isInterface(tmp_0, SerializableProperty()) : false) ? tmp_0 : THROW_CCE())));
}
function *race(races, $completion) {
  return yield* first(channelFlow(race$slambda(races)), $completion);
}
var BaseResourceUseClass;
function BaseResourceUse() {
  if (BaseResourceUseClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
        this.uses_1 = 0;
      }
      activate_yijg9v_k$() {
      }
      deactivate_pmdz1g_k$() {
      }
      beginUse_omrbby_k$() {
        var _unary__edvuaz = this.uses_1;
        this.uses_1 = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz === 0) {
          this.activate_yijg9v_k$();
        }
        var dead = {_v: false};
        return () => {
          var tmp;
          if (dead._v) {
            return Unit_instance;
          }
          dead._v = true;
          var tmp_0;
          this.uses_1 = this.uses_1 - 1 | 0;
          if (this.uses_1 === 0) {
            this.deactivate_pmdz1g_k$();
            tmp_0 = Unit_instance;
          }
          return Unit_instance;
        };
      }
    }
    initMetadataForClass($, 'BaseResourceUse');
    BaseResourceUseClass = $;
  }
  return BaseResourceUseClass;
}
function *waitFor(_this__u8e3s4, matching, $completion) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var this_0 = _this__u8e3s4.get_state_wc71uu_k$();
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
        tmp = null;
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          if (matching(_ReactiveState___get_raw__impl__92ipya(this_0).other_1))
            return Unit_instance;
          tmp = Unit_instance;
        } else {
          if (matching(_ReactiveState___get_raw__impl__92ipya(this_0)))
            return Unit_instance;
          tmp = Unit_instance;
        }
      }
    }
  }
  var close = {_v: null};
  try {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    (yield () => {
      var uCont = $completion;
      var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
      cancellable.initCancellability_shqc60_k$();
      var cont = cancellable;
      close._v = _this__u8e3s4.addListener_6y9mct_k$(() => {
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        var this_0 = _this__u8e3s4.get_state_wc71uu_k$();
        var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
        var tmp;
        if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
          tmp = null;
        } else {
          if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
            tmp = null;
          } else {
            if (tmp0_subject instanceof InternalReactiveThrownException()) {
              _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
              tmp = null;
            } else {
              if (tmp0_subject instanceof InternalReactiveWrapper()) {
                var it = _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
                if (matching(it)) {
                  // Inline function 'kotlin.coroutines.resume' call
                  var this_1 = cont;
                  // Inline function 'kotlin.Companion.success' call
                  var tmp$ret$23 = _Result___init__impl__xyqfz8(Unit_instance);
                  this_1.resumeWith_rk9gbt_k$(tmp$ret$23);
                }
                tmp = Unit_instance;
              } else {
                var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
                if (matching(it_0)) {
                  // Inline function 'kotlin.coroutines.resume' call
                  var this_2 = cont;
                  // Inline function 'kotlin.Companion.success' call
                  var tmp$ret$27 = _Result___init__impl__xyqfz8(Unit_instance);
                  this_2.resumeWith_rk9gbt_k$(tmp$ret$27);
                }
                tmp = Unit_instance;
              }
            }
          }
        }
        return Unit_instance;
      });
      return cancellable.getResult_fck196_k$();
    });
  }finally {
    var tmp0_safe_receiver = close._v;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
  return Unit_instance;
}
var ResourceUse$1Class;
function ResourceUse$1() {
  if (ResourceUse$1Class === VOID) {
    class $ {
      constructor($parentScope, $action) {
        this.$parentScope_1 = $parentScope;
        this.$action_1 = $action;
      }
      beginUse_omrbby_k$() {
        var job = Job(this.$parentScope_1.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance));
        launch(CoroutineScope(this.$parentScope_1.get_coroutineContext_115oqo_k$().plus_s13ygv_k$(job)), VOID, VOID, this.$action_1);
        return () => {
          job.cancel$default_8haxne_k$();
          return Unit_instance;
        };
      }
    }
    initMetadataForClass($);
    ResourceUse$1Class = $;
  }
  return ResourceUse$1Class;
}
var uses$1Class;
function uses$1() {
  if (uses$1Class === VOID) {
    class $ {
      constructor($this_uses, $resource) {
        this.$this_uses_1 = $this_uses;
        this.$resource_1 = $resource;
        this.uses_1 = 0;
        this.r_1 = null;
      }
      get_state_wc71uu_k$() {
        return this.$this_uses_1.get_state_wc71uu_k$();
      }
      addListener_6y9mct_k$(listener) {
        var _unary__edvuaz = this.uses_1;
        this.uses_1 = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz === 0) {
          this.r_1 = this.$resource_1.beginUse_omrbby_k$();
        }
        var original = this.$this_uses_1.addListener_6y9mct_k$(listener);
        return () => {
          original();
          var tmp;
          this.uses_1 = this.uses_1 - 1 | 0;
          if (this.uses_1 === 0) {
            var tmp0_safe_receiver = this.r_1;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver();
            this.r_1 = null;
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
      }
    }
    protoOf($).beginUse_omrbby_k$ = beginUse;
    initMetadataForClass($, VOID, VOID, VOID, [Reactive()]);
    uses$1Class = $;
  }
  return uses$1Class;
}
function race$slambda$slambda($this_channelFlow, $race) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* $this_channelFlow.send_44jogj_k$(yield* $($race($completion), $completion), $completion);
    return Unit_instance;
  }), 1);
}
function race$slambda($races) {
  return constructCallableReference(($this$channelFlow, $completion) => orPromise($completion, function *($completion) {
    var indexedObject = $races;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var race = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      launch($this$channelFlow, VOID, VOID, race$slambda$slambda($this$channelFlow, race));
    }
    return Unit_instance;
  }), 1);
}
//region block: init
Key_instance_0 = new (Key())();
//endregion
//region block: exports
export {
  BaseResourceUse as BaseResourceUse29ny90pfhtji3,
  InterruptibleDelay as InterruptibleDelay2c0xh0wdvl7bj,
  ResourceUse as ResourceUse2vo6us5ch1uy1,
  ensureTotal as ensureTotal1k0kavd9th17q,
  now as now3ay3meoyffvdk,
  uses as uses26aso754i5iou,
  waitFor as waitFor1tw43zglmblfo,
};
//endregion

//# sourceMappingURL=utils.mjs.map
